/* eslint-disable @typescript-eslint/naming-convention */
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    warnings: true,
    dist: false,
    build: 'DEF',
    BASE_URL: 'https://uat-nextbackoffice.grupoconstant.net',
    AUTH_BASE_URL: 'https://uat-nextauth.grupoconstant.net',
    previewUrl: 'https://uat-nextbo.grupoconstant.net/preview',
    applicationId: 'com.grupoconstant.nextbackofficeuat',
    environmentUri: 'env://xml.grupoconstant.com/environment/Uat',
    applicationUri: 'app://xml.cloudcodice.com/application/Backoffice',
    mobileApplicationId: [{ id: 'com.grupoconstant.nextuat', name: 'Next Uat' }],
    scopes: [
        'env://xml.grupoconstant.com/environment/Uat',
        'app://xml.cloudcodice.com/application/Backoffice'
    ],
    version: require('../../package.json').version,
    filePath: 'uat',
    drive: ':nextfiles-share',
    title: 'Next Backoffice UAT'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
